import API from "@/api/lib/api";

export const getParentCategoriesAndItems = async (restaurant_id, menu_id) => {
  
  try {
    const response = await API.get(`restaurant/${restaurant_id}/take-order/menu_item/${menu_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};


export const getCategoriesAndItemsByCategory = async (restaurant_id, menu_id, category_id) => {
  
  try {
    const response = await API.get(`restaurant/${restaurant_id}/take-order/menu_item/${menu_id}/category/${category_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};


export const getMenuItemEssentials = async (restaurant_id, menu_id) => {
  
  try {
    const response = await API.get(`restaurant/${restaurant_id}/take-order/menu_item/${menu_id}/essentials`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};


export const getMenuItemOptions = async (restaurant_id) => {
  try {
    const response = await API.get(`restaurant/${restaurant_id}/menu-item-options`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};


export const confirmTakeOrderApi = async (restaurant_id, orderData) => {
  try {
    const response = await API.post(`/restaurant/${restaurant_id}/order`, orderData);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};

export const orderReplaceItemApi = async ( order_id, replaceItemData) => {
  try {
    const response = await API.put(`/restaurant/order/${order_id}/replace-item`, replaceItemData);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};

export const repeatOrderApi = async (restaurant_id, order_id) => {
  try {
    const response = await API.post(`/restaurant/${restaurant_id}/cbd/reorder/${order_id}`);
    return response.data;
  }
  catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};


export const getOrdersApi = async (restaurant_id, stage, page, per_page, order_type = "created_at", search = "") => {
  
  try {
    const response = await API.get(`/restaurant/${restaurant_id}/orders?stage=${stage}&page=${page}&per_page=${per_page}&order_type=${order_type}&search_term=${search}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};



export const updatePaymentSplitApi = async (restaurant_id, order_id, splitData) => {
  try {
    const response = await API.post(`/restaurant/${restaurant_id}/orders/${order_id}/split-payments`, splitData);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};


export const getPaymentSplitApi = async (restaurant_id, order_id) => {
  try {
    const response = await API.get(`/restaurant/${restaurant_id}/orders/${order_id}/split-payments`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};

export const splitPaymentTerminalPaymentApi = async (restaurant_id, order_id, split_payment_id, payload) => {
  try {
    const response = await API.post(
      `/restaurant/${restaurant_id}/orders/${order_id}/split-payments/${split_payment_id}/terminal-payment`,
      payload
    );
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};

export const updateCourseWisePaymentApi = async ( restaurant_id, order_id, coursePaymentData) => {
  try {
    const response = await API.post(`/restaurant/${restaurant_id}/orders/${order_id}/course-wise-payments`, coursePaymentData);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || { 
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};


export const getCourseWisePaymentApi = async ( restaurant_id, order_id) => {
  try {
    const response = await API.get(`/restaurant/${restaurant_id}/orders/${order_id}/course-wise-payments`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};



export const updateCookingTimeApi = async ( order_id, cookingTimeData) => {
  try {
    const response = await API.put(`/restaurant/orders/${order_id}/update-cooking-time`, cookingTimeData);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};


export const changeOrderTypeApi = async ( order_id, orderTypeData) => {
  try {
    const response = await API.put(`/restaurant/orders/${order_id}/convert-order-type`, orderTypeData); 
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};

export const delayOrderApi = async (order_id, delayData) => {
  try {
    const response = await API.put(`/restaurant/orders/${order_id}/delay`, delayData);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};

export const deleteOrderApi = async ( restaurant_id, order_id) => { 
  try {
    const response = await API.delete(`/restaurant/${restaurant_id}/order/${order_id}`); 
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};


export const applyDiscountApi = async ( order_id, discountData) => { 
  try {
    const response = await API.put(`/restaurant/order/${order_id}/add-discount`, discountData);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};

export const appliedDiscountListApi = async (order_id) => {
  try {
    const response = await API.get(`/restaurant/order/${order_id}/discounts`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};

export const removeDiscountApi = async (orderDiscountId, order_id) => {
  try {
    let response;
    if (orderDiscountId) {
      response = await API.delete(`/restaurant/order-discounts/${orderDiscountId}`);
    } else {
      response = await API.put(`/restaurant/order/${order_id}/remove-discount`);
    }
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};


export const applyLoyaltyDiscountApi = async ( order_id, loyaltyData) => { 
  try {
    const response = await API.put(`/restaurant/order/${order_id}/add-loyalty-discount`, loyaltyData);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};

export const appliedLoyaltyDiscountListApi = async (order_id) => {
  try {
    const response = await API.get(`/restaurant/order/${order_id}/loyalty-discounts`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};


export const removeLoyaltyDiscountApi = async (orderLoyaltyDiscountId) => {
  try {
    const response = await API.delete(`/restaurant/order-loyalty-discounts/${orderLoyaltyDiscountId}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};


export const addTipsApi = async ( order_id, tipsData) => {
  try {
    const response = await API.put(`/restaurant/order/${order_id}/add-tip`, tipsData);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || { 
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};


export const serviceChargeSettingsApi = async ( restaurant_id, serviceChargeData) => {
  try {
    const response = await API.put(`/restaurant/${restaurant_id}/take-order-settings/service-charge`, serviceChargeData);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};


export const preOrderAdvanceAndConfirmationApi = async ( order_id, preOrderData) => {
  try {
    const response = await API.put(`/restaurant/orders/${order_id}/pre-order`, preOrderData);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};


export const updateOrderServiceChargeApi = async ( order_id, serviceChargeData) => {
  try {
    const response = await API.put(`/restaurant/order/${order_id}/update-service-charge`, serviceChargeData);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || { 
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};


export const cashPaymentApi = async (order_id, cashPaymentData) => {
  try {
    const response = await API.post(`restaurant/orders/${order_id}/payment`, cashPaymentData);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};

export const complementaryItemsApi = async ( order_id, complementaryData) => {
  try {
    const response = await API.put(`/restaurant/orders/${order_id}/complementary-items`, complementaryData);
    return response.data;
  }
  catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  } 
};

export const getSingleOrderApi = async ( order_id) => {
  try {
    const response = await API.get(`/restaurant/order/${order_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};


export const orderServingStatsApi = async ( order_id, servingStatsData) => {
  try {
    const response = await API.put(`/restaurant/orders/${order_id}/serving-status`, servingStatsData); 
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};
    


export const printCustomerReceiptApi = async ( order_id, printer_id = "") => {
  try {
    const response = await API.get(`/restaurant/orders/${order_id}/print-customer?printer_id=${printer_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};


export const printKitchenReceiptApi = async ( order_id, printer_id = "", item_ids = []) => {
  try {
    const queryParams = new URLSearchParams();

    if (printer_id !== undefined && printer_id !== null && `${printer_id}` !== "") {
      queryParams.append("printer_id", printer_id);
    }

    if (Array.isArray(item_ids) && item_ids.length > 0) {
      queryParams.append("item_id", JSON.stringify(item_ids));
    }

    const queryString = queryParams.toString();
    const response = await API.get(
      `/restaurant/orders/${order_id}/print-kitchen${queryString ? `?${queryString}` : ""}`
    );
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};

export const markOrderReadyApi = async (restaurant_id, order_id) => {
  try {
    const response = await API.post(`/restaurant/orders/${order_id}/kitchen-status/mark-ready`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};



export const pointUseApi = async (order_id, pointData) => {
  try {
    const response = await API.put(`/restaurant/order/${order_id}/apply-reward-points`, pointData);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};

export const completeUnpaidOrderApi = async (order_id, payload = {}) => {
  try {
    const response = await API.post(`/restaurant/orders/${order_id}/complete-unpaid`, payload);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};

export const markCashOnDeliveryPaidApi = async (order_id) => {
  try {
    const response = await API.post(`/restaurant/orders/${order_id}/cash-on-delivery/mark-paid`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};

export const getTopSellingItems = async (restaurant_id) => {
  try {
    const response = await API.get(
      `restaurant/${restaurant_id}/take-order/top-selling-items`
    );
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};

export const getNewArrivalItems = async (restaurant_id) => {
  try {
    const response = await API.get(
      `restaurant/${restaurant_id}/take-order/new-arrival-items`
    );
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};

export const printSplitPaymentApi = async (order_id, split_payment_id, printer_id = "") => {
  try {
    const queryParams = new URLSearchParams();

    if (printer_id !== undefined && printer_id !== null && `${printer_id}` !== "") {
      queryParams.append("printer_id", printer_id);
    }

    const queryString = queryParams.toString();
    const response = await API.get(
      `/restaurant/orders/${order_id}/split-payments/${split_payment_id}/print${queryString ? `?${queryString}` : ""}`
    );
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};

export const printCourseWisePaymentApi = async (restaurant_id, order_id, course_wise_payment_id, printer_id = "") => {
  try {
    const queryParams = new URLSearchParams();

    if (printer_id !== undefined && printer_id !== null && `${printer_id}` !== "") {
      queryParams.append("printer_id", printer_id);
    }

    const queryString = queryParams.toString();
    const response = await API.get(
      `/restaurant/${restaurant_id}/orders/${order_id}/course-wise-payments/${course_wise_payment_id}/print${queryString ? `?${queryString}` : ""}`
    );
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};

export const payByLinkApi = async (order_id, paymentData) => {
  try {
    const response = await API.post(`/restaurant/orders/${order_id}/pay-by-link`, paymentData);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};

export const cancelOrderPayByLinkApi = async (order_id) => {
  try {
    const response = await API.post(`/restaurant/orders/${order_id}/pay-by-link/cancel`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};

export const orderTerminalPaymentApi = async (order_id) => {
  try {
    const response = await API.post(`/restaurant/orders/${order_id}/terminal-payment`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};

export const applySpendOfferApi = async (order_id, offer_id) => {
  try {
    const response = await API.put(`/restaurant/order/${order_id}/apply-spend-offer`, { offer_id });
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong, please try again later.",
      }
    );
  }
};

export const markTerminalPaymentDoneApi = async (uuid) => {
  try {
    const response = await API.post(`/restaurant/terminal-payments/${uuid}/mark-done`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Failed to mark terminal payment as done.",
      }
    );
  }
};

export const cancelTerminalPaymentApi = async (uuid) => {
  try {
    const response = await API.post(`/restaurant/terminal-payments/${uuid}/cancel`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Failed to cancel terminal payment.",
      }
    );
  }
};

export const cancelPreOrderPayByLinkApi = async (order_id) => {
  try {
    const response = await API.post(`/restaurant/orders/${order_id}/pre-order/pay-by-link/cancel`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Failed to cancel pre-order payment link.",
      }
    );
  }
};

export const preOrderTerminalPaymentApi = async (order_id, advanceData) => {
  try {
    const response = await API.post(`/restaurant/orders/${order_id}/pre-order/terminal-payment`, advanceData);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Failed to dispatch pre-order terminal payment.",
      }
    );
  }
};

